// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-bar.small[data-v-1081aa3f] {\n  width: 35%;\n  height: 6px !important;\n}\n.alert[data-v-1081aa3f] {\n  font-weight: 500;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 20px;\n}\n.bountyBox[data-v-1081aa3f] {\n  padding: 10px;\n  border: 1px solid #80808073;\n  margin: 20px;\n  width: fit-content;\n}\n", ""]);
// Exports
module.exports = exports;
